const publicBackendUrl = process.env.NEXT_PUBLIC_BACKEND_URL
const internalBackendUrl = process.env.BACKEND_INTERNAL_URL
const legacyBackendUrl = process.env.BACKEND_URL

const normalizeUrl = (value?: string | null) =>
  (value || "http://localhost:4000/").replace(/\/+$/, "")

const resolvedPublicBackendUrl = normalizeUrl(
  publicBackendUrl || legacyBackendUrl || internalBackendUrl
)
const resolvedInternalBackendUrl = normalizeUrl(
  internalBackendUrl || publicBackendUrl || legacyBackendUrl
)

export const API_BASE_URL = resolvedPublicBackendUrl
export const BACKEND_INTERNAL_URL = resolvedInternalBackendUrl
export const STORE_BASE_CURRENCY = process.env.NEXT_PUBLIC_STORE_BASE_CURRENCY || "USD"
